import {
  SR_API_ACTION_HOUSEHOLD_LISTING_UNARCHIVE,
} from 'api/actionTypes';

export default function unArchiveApplication({
  state,
  apiClient,
}, {
  unArchiveReason,
  householdListingId,
}) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_LISTING_UNARCHIVE,
    queryId: String(householdListingId),
    state: state,
    payload: {
      unArchiveReason,
      householdListingId,
    },
  });
}
